var PromotedTyreSideBox = (function () {
    var enabled = true;
    var productSideBoxInitialTopOffset = "52px";
    var productSideBoxTopOffset = 50;
    var productSideBoxBottomOffset = 66;

    function initialize() {
        $(window).on('scroll', function () {
            var productSideBox = $('#promoted-tyre-side-box');
            var productSideBoxHeight = productSideBox.height();
            var productList = $('.productListComponent');
            var productListTop = productList.offset().top;
            var productListBottom = productList.outerHeight(true) - productSideBoxHeight;

            var scrollY = $(this).scrollTop();
            if (scrollY < productListTop) {
                productSideBox.css({top: productSideBoxInitialTopOffset});
            } else if (scrollY >= productListTop && scrollY <= productListBottom) {
                productSideBox.css({top: (scrollY - productSideBoxHeight / 2) + productSideBoxTopOffset + "px"});
            } else if (productListBottom > 0 && scrollY > productListBottom) {
                productSideBox.css({top: productListBottom + "px"});
            }
        });
    }

    return {
        initialize: initialize,

        setEnabled: function(value) {
            if (typeof value !== 'boolean') {
                console.error("Boolean value is required");
                return;
            }
            enabled = value;
        },

        isEnabled: function () {
            return enabled;
        },

        hide: function() {
            $('#promoted-tyre-side-box').hide();
        }
    };
})();